import {
  type PassioFoodDataInfo,
  type PassioLocalizationConfig,
  type PassioAuth,
  normalizePassioSearchResultsFromRest,
  buildPassioRequestHeaders,
  fetchPassioWithRetry,
} from "@notemeal/passio-utils";

export type PassioSearchAuthContext = {
  getAuth: () => Promise<PassioAuth>;
  invalidateAuth: () => void;
};

export const searchPassioSemantic = async (
  authContext: PassioSearchAuthContext,
  term: string,
  localization: PassioLocalizationConfig,
  limit = 25
): Promise<{ results: PassioFoodDataInfo[]; alternatives: string[] }> => {
  const auth = await authContext.getAuth();
  const headers = buildPassioRequestHeaders(auth, localization);

  const url = new URL(`${import.meta.env.VITE_PASSIO_PRODUCTS_BASE}/napi/food/search/semantic`);
  url.searchParams.set("term", term);
  url.searchParams.set("limit", String(limit));

  const response = await fetchPassioWithRetry(url.toString(), { headers }, authContext);
  if (!response.ok) {
    throw new Error(`Branded food search failed (${response.status})`);
  }

  const payload = (await response.json()) as Parameters<typeof normalizePassioSearchResultsFromRest>[0];
  const normalized = normalizePassioSearchResultsFromRest(payload);
  return {
    results: normalized.results,
    alternatives: normalized.alternatives ?? normalized.alternateNames ?? [],
  };
};
